import React, { useEffect, useState } from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import Opinion from "./MyOpinion.module.css";
import BurgerMenuTitle from "../../Component/BurgerMenuTitle/BurgerMenuTitle";
import { faCalendarAlt, faStar } from "@fortawesome/free-solid-svg-icons";
import { getCommentsPro, getCommentsSup } from "../../Api/ClientServices";
import PointSpreadLoading from "react-loadingg/lib/PointSpreadLoading";
import {
  RemoveProductComment,
  RemoveSupplierComment,
} from "../../Api/BarestServices";
import { errorToast } from "../../Toast/Toast";
function MyOpinion() {
  const [product, setProduct] = useState([]);
  const [suplier, setSuplier] = useState([]);
  useEffect(() => {
    getCommentsSupery();
    getCommentsFood();
  }, []);

  function CommentCondition(props) {
    const status = props.status;

    switch (status) {
      case "0":
        return (
          <h2
            className={Opinion.comCondition}
            style={{ color: "rgb(0, 183, 255)" }}
          >
            خوانده نشده
          </h2>
        );
      case "1":
        return (
          <h2
            className={Opinion.comCondition}
            style={{ color: "rgb(19, 175, 45)" }}
          >
            تایید شده
          </h2>
        );
      case "-1":
        return (
          <>
            <h2
              className={Opinion.comConditionRight}
              style={{ color: "#9B0000" }}
            >
              {" "}
              رد شده
            </h2>
            <h2
              className={Opinion.comConditionLeft}
              style={{ color: "#9B0000" }}
            >
              {props.cause}
            </h2>
          </>
        );

      default:
        return <h2 className={Opinion.comCondition}> </h2>;
    }
  }

  const getCommentsSupery = async () => {
    getCommentsPro((succ, res) => {
      if (succ) {
        if (res.status === 1) {
          errorToast("مشکلی پیش آمده است");
        } else {
          setProduct(res.comments);
        }
      } else {
        console.error(res);
      }
    });
  };
  const getCommentsFood = async () => {
    getCommentsSup((succ, res) => {
      if (succ) {
        if (res.status === 1) {
          errorToast("مشکلی پیش آمده است");
        } else {
          setSuplier(res.comments);
        }
      } else {
        console.error(res);
      }
    });
  };

  const DeleteHandlerProduct = (id) => {
    let CommentId = {
      id: id,
    };
    RemoveProductComment(CommentId, (res) => {
      getCommentsSupery();
      getCommentsFood();
    });
  };
  const DeleteHandlerSuplier = (id) => {
    let CommentId = {
      id: id,
    };
    RemoveSupplierComment(CommentId, (res) => {
      getCommentsSupery();
      getCommentsFood();
    });
  };
  let loading = null;
  if (product === undefined && suplier === undefined) {
    loading = <PointSpreadLoading color={"#ab0c59"} size={"small"} />;
  } else {
    if (suplier.length === 0 && product.length === 0) {
      loading = <h2 className={Opinion.text}>!نظری یافت نشد</h2>;
    } else {
      loading = (
        <div
          style={{
            marginTop: "4rem",
            width: "90%",
            display: "flex",
            flexDirection: "column",
            alignItems: "center",
          }}
        >
          {suplier.map((item) => {
            return (
              <section key={item.id} className={Opinion.ideas}>
                <div className={Opinion.PartOne}>
                  <div className={Opinion.PicHolder}>
                    <img
                      src={`//cdn.barest.ir/product/m/${item.id}.jpg`}
                      alt={item.name}
                    />
                  </div>
                  <div className={Opinion.Information}>
                    <h2 className={Opinion.RestaurantName}>{item.name}</h2>
                    <div className={Opinion.DateTime}>
                      <span className={Opinion.Date}>
                        <FontAwesomeIcon
                          className={Opinion.icon}
                          icon={faCalendarAlt}
                        />
                        {item.date}{" "}
                      </span>
                    </div>
                    <div className={Opinion.StoreRate}>
                      <div className={Opinion.FixRate}>
                        <div className={Opinion.RateHolder}>
                          <div className={Opinion.grayStar}>
                            <FontAwesomeIcon icon={faStar} />
                            <FontAwesomeIcon icon={faStar} />
                            <FontAwesomeIcon icon={faStar} />
                            <FontAwesomeIcon icon={faStar} />
                            <FontAwesomeIcon icon={faStar} />
                          </div>
                          <div
                            className={Opinion.GoldStar}
                            style={{ width: `${item.score * 20}%` }}
                          >
                            <div className={Opinion.GoldStarHolder}>
                              <FontAwesomeIcon icon={faStar} />
                              <FontAwesomeIcon icon={faStar} />
                              <FontAwesomeIcon icon={faStar} />
                              <FontAwesomeIcon icon={faStar} />
                              <FontAwesomeIcon icon={faStar} />
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                  <CommentCondition status={item.status} cause={item.cause} />
                </div>
                <div className={Opinion.opinion}>{item.message}</div>
                <div
                  className={Opinion.delete}
                  onClick={() => DeleteHandlerSuplier(item.id)}
                >
                  حذف نظر
                </div>
              </section>
            );
          })}
          {product.map((item) => {
            return (
              <section key={item.id} className={Opinion.ideas}>
                <div className={Opinion.PartOne}>
                  <div className={Opinion.PicHolder}>
                    <img
                      src={`//cdn.barest.ir/product/m/${item.id}.jpg`}
                      alt={item.name}
                    />
                  </div>
                  <div className={Opinion.Information}>
                    <h2 className={Opinion.RestaurantName}>{item.name}</h2>
                    <div className={Opinion.DateTime}>
                      <span className={Opinion.Date}>
                        <FontAwesomeIcon
                          className={Opinion.icon}
                          icon={faCalendarAlt}
                        />
                        {item.date}
                      </span>
                    </div>
                    <div className={Opinion.StoreRate}>
                      <div className={Opinion.FixRate}>
                        <div className={Opinion.RateHolder}>
                          <div className={Opinion.grayStar}>
                            <FontAwesomeIcon icon={faStar} />
                            <FontAwesomeIcon icon={faStar} />
                            <FontAwesomeIcon icon={faStar} />
                            <FontAwesomeIcon icon={faStar} />
                            <FontAwesomeIcon icon={faStar} />
                          </div>
                          <div
                            className={Opinion.GoldStar}
                            style={{ width: `${item.score * 20}%` }}
                          >
                            <div className={Opinion.GoldStarHolder}>
                              <FontAwesomeIcon icon={faStar} />
                              <FontAwesomeIcon icon={faStar} />
                              <FontAwesomeIcon icon={faStar} />
                              <FontAwesomeIcon icon={faStar} />
                              <FontAwesomeIcon icon={faStar} />
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <div className={Opinion.opinion}>{item.message}</div>
                <div
                  className={Opinion.delete}
                  onClick={() => DeleteHandlerProduct(item.id)}
                >
                  حذف نظر
                </div>
                <CommentCondition status={item.status} cause={item.cause} />
              </section>
            );
          })}
        </div>
      );
    }
  }

  return (
    <div className={Opinion.pageHolder}>
      <BurgerMenuTitle title="نظرات من" />
      {loading}
    </div>
  );
}

export default MyOpinion;
